import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { GetChildMenuList } from "../../store/childMenuAtom";

function ChildMenuSideBar({ viewItemDetails }) {
    const getChildMenuData = GetChildMenuList();
    const { id } = useParams();

    const childMenus = getChildMenuData?.menu_child_info || [];

    const grouped = useMemo(() => {
        const map = {};
        childMenus.forEach(item => {
            const key = item.menu_parent_id;
            if (!map[key]) map[key] = { name: item.menu_parent_name, items: [] };
            map[key].items.push(item);
        });
        return map;
    }, [childMenus]);

    return (
        <section className="w-64 border border-gray-200 rounded-xl bg-white shadow-sm overflow-hidden">
            <div className="px-4 py-3 border-b border-gray-100 bg-gray-50">
                <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">Child Menus</p>
                <p className="text-xs text-gray-400 mt-0.5">{childMenus.length} total</p>
            </div>

            <div className="overflow-y-auto max-h-[calc(100vh-220px)]">
                {Object.entries(grouped).map(([parentId, group]) => (
                    <div key={parentId}>
                        <div className="px-4 py-2 bg-gray-50 border-b border-gray-100 sticky top-0 z-10">
                            <span className="text-[10px] font-bold text-indigo-500 uppercase tracking-widest">
                                {group.name}
                            </span>
                            <span className="ml-2 text-[10px] text-gray-400">{group.items.length}</span>
                        </div>

                        {group.items.map(item => {
                            const isActive = String(id) === String(item.menu_id);
                            return (
                                <div
                                    key={item.menu_id}
                                    onClick={() => viewItemDetails(item.menu_id)}
                                    className={`flex items-center justify-between px-4 py-2.5 border-b border-gray-50 cursor-pointer transition-colors
                                        ${isActive
                                            ? 'bg-blue-50 border-l-2 border-l-blue-500'
                                            : 'hover:bg-gray-50 border-l-2 border-l-transparent'}`}
                                >
                                    <div className="flex-1 min-w-0">
                                        <p className={`text-sm font-medium truncate ${isActive ? 'text-blue-700' : 'text-gray-700'}`}>
                                            {item.menu_name}
                                        </p>
                                        <p className="text-xs text-gray-400">ID: {item.menu_id}</p>
                                    </div>
                                    <span className={`ml-2 flex-shrink-0 w-1.5 h-1.5 rounded-full ${item.status_id === 'A' ? 'bg-green-400' : 'bg-red-400'}`} />
                                </div>
                            );
                        })}
                    </div>
                ))}

                {childMenus.length === 0 && (
                    <p className="text-xs text-gray-400 text-center py-8">No items found</p>
                )}
            </div>
        </section>
    );
}

export default ChildMenuSideBar;
